module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-theme--dark"
  }, [_c('div', {
    staticClass: "mdc-switch"
  }, [_c('input', {
    staticClass: "mdc-switch__native-control",
    attrs: {
      "type": "checkbox",
      "id": "basic-switch"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.update
    }
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-switch__background"
  }, [_c('div', {
    staticClass: "mdc-switch__knob"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f218bac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MaterialComponents/MdcSwitch.vue
// module id = 642
// module chunks = 1